export default __webpack_public_path__ + "static/contact-history-d4e8e806b3ced54776d1321487616c0f.mp4";